import { all, takeEvery } from 'redux-saga/effects';
import * as ActionTypes from '../actions/actionTypes';
import AddMemberSaga from './organizations/AddMemberSaga';
import LogoutSaga from './auth/LogoutSaga';
import AddPortalSaga from './map/AddPortalSaga';
import AddConnectorSaga from './map/AddConnectorSaga';
import UpdateWidgetSaga from './map/UpdateWidgetSaga';
import UpdateMapSaga from './map/UpdateMapSaga';
import RemoveWidgetSaga from './map/RemoveWidgetSaga';
import RemoveConnectorSaga from './map/RemoveConnectorSaga';
import { AddHistoryRecordSaga } from './history';

export default function* rootSaga(getFirebase) {
  yield all([
    takeEvery(ActionTypes.ADD_MEMBER, AddMemberSaga, getFirebase),
    takeEvery(ActionTypes.LOGOUT, LogoutSaga, getFirebase),
    takeEvery(ActionTypes.MAP_ADD_PORTAL_REQUEST, AddPortalSaga, getFirebase),
    takeEvery(ActionTypes.MAP_ADD_CONNECTOR_REQUEST, AddConnectorSaga, getFirebase),
    takeEvery(ActionTypes.MAP_UPDATE_WIDGET_REQUEST, UpdateWidgetSaga, getFirebase),
    takeEvery(ActionTypes.MAP_UPDATE_REQUEST, UpdateMapSaga, getFirebase),
    takeEvery(ActionTypes.MAP_REMOVE_WIDGET, RemoveWidgetSaga, getFirebase),
    takeEvery(ActionTypes.MAP_REMOVE_CONNECTOR, RemoveConnectorSaga, getFirebase),
    takeEvery(ActionTypes.HISTORY_ADD_RECORD, AddHistoryRecordSaga, getFirebase),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js